import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { currentSession, impersonationActive, listImpersonationUsers, startImpersonation } from '../../service/impersonation';

export default function ImpersonateUser() {
    const [visible, setVisible] = useState(false);
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const me = currentSession()?.data?.adminUser;
    if (!['admin', 'superAdmin'].includes(me?.role?.uid) || impersonationActive()) return null;
    const open = async () => {
        setVisible(true); setBusy(true); setError(''); setSelected(null); setUsers([]);
        try {
            const items = await listImpersonationUsers();
            setUsers(items.filter(user => user._id !== me._id).map(user => ({ ...user,
                label: `${[user.firstName, user.lastName].filter(Boolean).join(' ')} · ${user.email} · ${user.role?.title || 'Sin rol'}`
            })));
        } catch (err) { setError(err.response?.data?.message || 'No pudimos cargar los usuarios.'); }
        finally { setBusy(false); }
    };
    const start = async () => {
        setBusy(true); setError('');
        try { await startImpersonation(selected); }
        catch (err) { setError(err.response?.data?.message || err.message); setBusy(false); }
    };
    return <>
        <Button label="Entrar como usuario" icon="pi pi-users" className="p-button-outlined p-button-sm" onClick={open} />
        <Dialog header="Entrar como usuario" visible={visible} onHide={() => setVisible(false)} closable={!busy} modal draggable={false} style={{ width: '600px', maxWidth: '95vw' }}>
            <p>Usarás Syncro con la identidad y los permisos actuales del usuario. Las acciones que realices se guardarán y quedará registrado que tú las hiciste en su nombre.</p>
            <p>La sesión dura hasta una hora y se aplica a las pestañas abiertas de Syncro en este navegador.</p>
            <label htmlFor="impersonation-user" className="block mb-2">Usuario</label>
            <Dropdown inputId="impersonation-user" value={selected} options={users} optionLabel="label" optionValue="_id" onChange={e => setSelected(e.value)} filter filterBy="label" placeholder={busy ? 'Cargando…' : 'Buscar por nombre o correo'} className="w-full" disabled={busy} />
            {error && <p role="alert" className="text-red-600">{error}</p>}
            <div className="flex justify-content-end mt-4"><Button label="Entrar como este usuario" icon="pi pi-sign-in" onClick={start} disabled={!selected || busy} loading={busy} /></div>
        </Dialog>
    </>;
}
